function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */
import { getOrThrow } from '@deephaven/utils';
import { isExpandableGridModel } from "./ExpandableGridModel.js";
import GridRenderer from "./GridRenderer.js";
import memoizeClear from "./memoizeClear.js";
class CellRenderer {
  constructor() {
    _defineProperty(this, "getCachedTruncatedString", memoizeClear((context, text, width, fontWidthLower, fontWidthUpper, truncationChar) => GridRenderer.truncateToWidth(context, text, width, fontWidthLower, fontWidthUpper, truncationChar), {
      max: 10000
    }));
  }
  drawCellRowTreeMarker(context, state, row) {
    var metrics = state.metrics,
      model = state.model,
      mouseX = state.mouseX,
      mouseY = state.mouseY,
      theme = state.theme;
    var firstColumn = metrics.firstColumn,
      gridX = metrics.gridX,
      gridY = metrics.gridY,
      allColumnXs = metrics.allColumnXs,
      allColumnWidths = metrics.allColumnWidths,
      allRowYs = metrics.allRowYs,
      allRowHeights = metrics.allRowHeights,
      visibleRowTreeBoxes = metrics.visibleRowTreeBoxes;
    var treeMarkerColor = theme.treeMarkerColor,
      treeMarkerHoverColor = theme.treeMarkerHoverColor;
    var columnX = getOrThrow(allColumnXs, firstColumn);
    var columnWidth = getOrThrow(allColumnWidths, firstColumn);
    var rowY = getOrThrow(allRowYs, row);
    var rowHeight = getOrThrow(allRowHeights, row);
    if (!isExpandableGridModel(model) || !model.isRowExpandable(row)) {
      return;
    }
    var treeBox = getOrThrow(visibleRowTreeBoxes, row);
    var color = mouseX != null && mouseY != null && mouseX >= gridX + columnX && mouseX <= gridX + columnX + columnWidth && mouseY >= gridY + rowY && mouseY <= gridY + rowY + rowHeight ? treeMarkerHoverColor : treeMarkerColor;
    this.drawTreeMarker(context, state, columnX, rowY, treeBox, color, model.isRowExpanded(row));
  }
  drawTreeMarker(context, state, columnX, rowY, treeBox, color, isExpanded) {
    var x1 = treeBox.x1,
      y1 = treeBox.y1,
      x2 = treeBox.x2,
      y2 = treeBox.y2;
    var markerText = isExpanded ? '⊟' : '⊞';
    var textX = columnX + (x1 + x2) * 0.5 + 0.5;
    var textY = rowY + (y1 + y2) * 0.5 + 0.5;
    context.fillStyle = color;
    context.textAlign = 'center';
    context.fillText(markerText, textX, textY);
  }
}
export default CellRenderer;
//# sourceMappingURL=CellRenderer.js.map